import RouteEndpointsItems from './items';
import RouteEndpointsMerks from './merks';

const RouteEndpointsItemManagement = {
  ...RouteEndpointsMerks,
  ...RouteEndpointsItems,
} as const;

export default RouteEndpointsItemManagement;
